module.exports = "pegasus/assets/theme6/l_d.png";